import React, { MouseEvent, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import ChildFilterItem from "./ChildFilterItem";
import ArtistUtilities, { filterObject } from "./FindAnArtistUtils";
import GlobalService from "../../services/GlobalService";

interface FilterItemProps {
    item: any;
    sendTypeListToParent: (typeList: filterObject, selected: boolean, parentNodeClicked: boolean, deSelectType: boolean,isEnter:boolean) => void;
    initialSelected?: boolean;
}

interface FilterItemState {
    selected: boolean;
    listItem: any;
    parentNodeClicked: boolean;
    IdList: string[];
    count: number;
    filterObject: filterObject;
    typeList: string[];
    childResetKeys: { [id: string]: number };
}

class FilterItem extends React.Component<FilterItemProps> {
    state: FilterItemState;
    utils: ArtistUtilities;

    constructor(props: FilterItemProps) {
        super(props);
        this.utils = new ArtistUtilities();
        this.state = {
            selected: props.initialSelected ?? false,
            listItem: this.props.item,
            parentNodeClicked: false,
            IdList: [],
            count: this.props.item.typeOptions.length,
            filterObject: this.utils.initializeFilterObject(),
            typeList: [],
            childResetKeys: {},
        };
        this.toggleSelected = this.toggleSelected.bind(this);
    }

    componentDidMount() {
        var typeListObject: filterObject = this.utils.initializeFilterObject();
        typeListObject = this.utils.extractTypes(this.props.item);
        this.setState({
            filterObject: typeListObject,
        });
    }

    toggleParentState = (listItem: any, state: boolean,isEnter:boolean) => {
        var typeObject: filterObject = this.state.filterObject;
        let deSelectType: boolean = false;
        let typeList: string[];
        let IdList: string[];
        if(!isEnter){
            if (state) {
                // Single-select: replace any existing selection with just this one child
                IdList = [listItem.id];
                typeList = [listItem.value];
                typeObject.types = IdList;
                // Increment reset keys for all OTHER children so they remount unselected
                const newChildResetKeys = { ...this.state.childResetKeys };
                (this.state.listItem.typeOptions || []).forEach((opt: any) => {
                    if (opt.id.toString() !== listItem.id.toString()) {
                        const k = opt.id.toString();
                        newChildResetKeys[k] = (newChildResetKeys[k] || 0) + 1;
                    }
                });
                this.setState({ childResetKeys: newChildResetKeys });
            } else {
                IdList = [];
                typeList = [];
                GlobalService.removeArtistTypeSubType(typeObject.serviceSubtype, listItem.id);
                typeObject.types = IdList;
                deSelectType = true;
            }
        } else {
            IdList = this.state.IdList;
            typeList = this.state.typeList;
        }

        this.setState({
            IdList: IdList,
            selected: IdList.length > 0 ? true : false,
            parentNodeClicked: false,
            typeList: typeList,
        }, () => { this.props.sendTypeListToParent(typeObject, this.state.selected, this.state.parentNodeClicked, deSelectType,isEnter) });
    };

    toggleSelected(e:any){
        e.preventDefault();
        let iskeyDown = e.type && e.type === 'keydown' ? true:false;
        let isEnter = this.checkIsEnter(e);
        if(iskeyDown && !isEnter){
            return;
        }
        this.setState(
            (prevState: FilterItemState) => ({
                // selected: !prevState.selected,
                // selected: iskeyDown || isEnter? prevState.selected : !prevState.selected,
                selected: isEnter? prevState.selected : !prevState.selected,
                parentNodeClicked: true,
            }),
            () => {
                this.createIdListOnParentClcik(isEnter)
            }
        );
    }

    checkIsEnter = (e: any) => {
        let isEnter = false;
        if (e.type && e.type === 'keydown') {
            e.preventDefault();
            if (e.key && e.key === 'Enter')
                isEnter = true;
        }
        return isEnter;
    }

    createIdListOnParentClcik = (isEnter:boolean) => {
        var typeObject: filterObject = this.state.filterObject;
        var ListItem: string[] = [];
        var typeListItem: string[] = [];
        if (this.state.parentNodeClicked) {
            if (this.state.selected) {
                // Single-select: keep current child selections; do NOT auto-select all children
                ListItem = this.state.IdList;
                typeListItem = this.state.typeList;
            } else {
                ListItem = [];
                typeListItem = [];
            }
            typeObject.types = ListItem;
        }
        this.setState({
            IdList: ListItem,
            typeList: typeListItem,
        });
        this.props.sendTypeListToParent(typeObject, this.state.selected, this.state.parentNodeClicked, false,isEnter);
    };

    render() {
        return (
            <li>
                <button type='button'
                    className={`filter-item ${this.state.selected ? "filter-item--selected" : ""}`}
                    onClick={this.toggleSelected}
                    onKeyDown={this.toggleSelected}
                >
                    <span className="filter-item__icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </span>
                    {this.state.listItem.value}
                </button>
                {this.state.listItem.typeOptions && this.state.listItem.typeOptions.length > 1 ? (
                    <ul className="filter-box__filter-list filter-item__children">
                        {this.state.listItem.typeOptions.map((filterItem: any, index: number) => {
                            return (
                                <li key={filterItem.id}>
                                    <ChildFilterItem
                                        key={filterItem.id.toString() + '-' + (this.state.childResetKeys[filterItem.id.toString()] || 0)}
                                        item={filterItem}
                                        selectFilterType={this.toggleParentState}
                                        parentNodeselected={this.state.parentNodeClicked}
                                        selected={this.state.selected}
                                    />
                                </li>
                            );
                        })}{" "}
                    </ul>
                ) : null}
            </li>
        );
    }
}

export default FilterItem;
